<template>
  <div v-if="!loading">
    <div v-if="flightSelector == 'roundTrip'">
      <pack-flight-journey :flight="selectedFlights.journey" opened>
        <div class="items-center w-full relative py-4 pl-2 pr-14 lg:p-6">
          <single-flight-info :flight="selectedFlights.journey" direction="journey" class="w-full">
            <v-btn color="secondary" class="hidden md:block font-bold" rounded text elevation="0"
              @click="setFlightSelector('journey')">
              <span>{{ $t('footer.change_flights') }}</span>
            </v-btn>
          </single-flight-info>
        </div>
        <template v-slot:footer>
          <v-btn color="secondary" class="font-bold" rounded text elevation="0" @click="setFlightSelector('journey')">
            <span>{{ $t('footer.change_flights') }}</span>
          </v-btn>
        </template>
      </pack-flight-journey>
      <pack-flight-journey :flight="selectedFlights.return" opened>
        <div class="items-center w-full relative py-4 pl-2 pr-14 lg:p-6">
          <single-flight-info :flight="selectedFlights.return" direction="journey" class="w-full">
            <v-btn color="secondary" class="hidden md:block font-bold" rounded text elevation="0"
              @click="setFlightSelector('return')">
              <span>{{ $t('footer.change_flights') }}</span>
            </v-btn>
          </single-flight-info>
        </div>
        <template v-slot:footer>
          <v-btn color="secondary" rounded text elevation="0" class="font-bold" @click="setFlightSelector('journey')">
            <span>{{ $t('footer.change_flights') }}</span>
          </v-btn>
        </template>
      </pack-flight-journey>
    </div>
    <div v-else-if="flights.length" class="flights-container">
      <div>
        <pack-flight-journey v-for="flight in flights" :key="flight.id" :flight="flight">
          <div class="items-center w-full relative py-4 pl-2 lg:p-6">
            <single-flight-info :flight="flight" direction="journey" class="w-full" price>
              <v-btn rounded light block elevation="0" color="secondary" class="mx-auto md:block hidden font-bold"
                @click="selectJourneyFlight(flight)">
                {{packPrice(flight.price) >= 0 ? '+' : ''}}{{ packPrice(flight.price) | currency_no_decimals }}
              </v-btn>
            </single-flight-info>
          </div>
          <template v-slot:footer>
            <v-btn rounded light block elevation="0" color="secondary" class="mx-auto font-bold"
              @click="selectJourneyFlight(flight)">
              {{packPrice(flight.price) >= 0 ? '+' : ''}}{{ packPrice(flight.price) | currency_no_decimals }}
            </v-btn>
          </template>
        </pack-flight-journey>
      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="flightSelector == 'journey'">
      <skeleton-loader
        :progress="progress"
        :loadingText="loadingText"
        customSkeletonClass="custom-skeleton-return"
        skeletonType="date-picker-options"
        :showProgressBar="true"
      />
    </div>
    <div v-if="flightSelector == 'return'">
      <skeleton-loader
        :progress="progress"
        customSkeletonClass="custom-skeleton-roundtrip mt-4"
        skeletonType="table"
        :showProgressBar="false"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import PackFlightJourney from "./PackFlightJourney.vue";
import { SET_JOURNEY_FLIGHT } from "../../../store/nights/action-types";
import { NIGHTS_SET_FLIGHT, SET_FLIGHT_SELECTOR, SET_RETURN_FLIGHT } from "../../../store/nights/mutation-types";
import SingleFlightInfo from "./SingleFlightInfo.vue";
import { GET_FLIGHT_SELECTOR, NIGHTS_GET_TOTAL_PRICE } from "../../../store/nights/getter-types";
import SkeletonLoader from './SkeletonLoader.vue';
import Vue from "vue";

export default {
  components: { PackFlightJourney, SingleFlightInfo, SkeletonLoader },
  data() {
    return {
      loading: false,
      progress: 0,
      loadingText: "Inicializando la carga de vuelos...",
    }
  },
  computed: {
    ...mapGetters({
      flightSelector: GET_FLIGHT_SELECTOR,
      finalPrice: NIGHTS_GET_TOTAL_PRICE,
    }),
    flight() {
      return this.$store.state.nights.flight;
    },
    flights() {
      return this.flightSelector == "journey" ? this.$store.state.nights.resources.flights : this.$store.state.nights.resources.returnFlights;
    },
    selectedFlights() {
      return this.$store.state.nights.selectedFlights;
    },
    bundlePrice() {
      return this.$store.state.nights.bundlePrice;
    },
    test() {
      return this.flightSelector;
    }
  },
  watch: {
    flightSelector: function (val) {
      if (val == 'journey' || val == 'return') {
        this.setFlight({
          ...this.flight,
          definitive: false
        })
      }
    }
  },
  methods: {
    ...mapMutations({
      setFlight: NIGHTS_SET_FLIGHT,
      setFlightSelector: SET_FLIGHT_SELECTOR
    }),
    ...mapActions({
      setJourneyFlight: SET_JOURNEY_FLIGHT,
      setReturnFlight: SET_RETURN_FLIGHT
    }),
    packPrice(flightPrice) {
      let price = this.bundlePrice + flightPrice;
      let result = price - this.finalPrice;

      if(result >= -5 && result <= 5) result = 0

      return result;
    },
    async selectJourneyFlight(flight) {
      this.loading = true;

      if (this.flightSelector == 'journey') {
        this.progress = 0;
        this.startProgress();

        await this.setJourneyFlight(flight);
        this.setFlightSelector('return');

        this.loading = false;
      } else {
        this.setReturnFlight(flight)
        .then(() => {
          this.setFlightSelector('roundTrip');

        }).catch(() => {
          this.$toastr.e("No se ha podido encontrar una configuración de vuelos adecuada. Prueba otra fecha");
        }).finally(() => {
          Vue.nextTick(() => {
            this.loading = false;
          })
        });
      }
    },
    startProgress() {
      const progressInterval = setInterval(() => {
        if (this.progress >= 100) {
          clearInterval(progressInterval);
          this.loadingText = "Carga completa. Listo para continuar.";
          this.loading = false;
        } else {
          this.progress += 2;

          if (this.progress < 30) {
            this.loadingText = "Obteniendo vuelos disponibles...";
          } else if (this.progress >= 30 && this.progress < 60) {
            this.loadingText = "Cargando horarios de los vuelos...";
          } else if (this.progress >= 60 && this.progress < 90) {
            this.loadingText = "Preparando detalles finales...";
          } else {
            this.loadingText = "Casi listo...";
          }
        }
      }, 100);
    },
  }
}
</script>
<style scoped lang="scss">
.custom-skeleton {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  margin-bottom: 20px;

  &-return {
    height: 80px;
  }

  &-roundtrip {
    height: 150px;
  }
}

.bg-navy {
  background-color: #1a2a6c;
}

.animate-pulse {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>

